import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/auth/AuthShell";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { refresh } = useAuth();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => { setStatus("ok"); refresh(); })
      .catch(() => setStatus("error"));
  }, [token, refresh]);

  return (
    <AuthShell title="Email verification" subtitle="">
      <div className="flex flex-col items-center py-4 text-center">
        {status === "verifying" && <><Loader2 className="h-10 w-10 animate-spin text-medorange" /><p className="mt-3 text-sm text-slate-500">Verifying your email…</p></>}
        {status === "ok" && <><CheckCircle2 className="h-12 w-12 text-emerald-500" /><p className="mt-3 text-sm font-semibold text-slate-700">Your email is verified!</p></>}
        {status === "error" && <><XCircle className="h-12 w-12 text-red-500" /><p className="mt-3 text-sm text-slate-600">This verification link is invalid or has expired.</p></>}
        <Link to="/" className="mt-5 rounded-full bg-medorange px-5 py-2 text-sm font-semibold text-white">Go to MedLync</Link>
      </div>
    </AuthShell>
  );
}
